import React, { useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import "./channelBox.css";
import { IP } from "../../../../internalServer";
import assets from "../../../../assets/assets";
import { useLocation } from "react-router-dom";

const ChannelBox = ({
  communityData,
  postCreatedCount,
  setActive,
  postRequestCount,
  setViewFirstInProgress,
  selectedCommunity,
  postData
}) => {
  const { state } = useLocation()
  return communityData ? (
    <div
      // className="d-flex my-1 py-2 align-items-center gap-2 channel_name_box"
      className="d-flex my-1 py-2  gap-2 mb-2 channel_name_box w-100 rounded-3 shadow-sm"
      style={{ backgroundColor: "white" }}
    >
      <img
        className="channel_icon"
        src={`${IP}${communityData.profile_picture}`}
        alt="icon"
        //Handle onload image error
        onError={(e) => {
          e.target.src = assets.CommunityImg
        }}
      />
      <div className="d-flex flex-column gap-1 channel_data w-80">
        <NavLink to={`/viewFirstScreen`} className="link" state={{ communityId: communityData?.id, postId: postData?.id }}>
          <span
            onClick={() => {
              state?.communityId !== communityData?.id && setViewFirstInProgress(true);
              setActive("About");
            }}
            className="comments-text channel_name text-blue-950"
            style={{ width: "50%" }}
          >
            {communityData?.community_name}
          </span>
        </NavLink>

        <span className="created_by pr-4">
          <div className="w-full flex justify-between text-[12px] text-black">
            <div> Created By:</div>
            <div>{communityData?.user_id?.name}</div>
          </div>

          <div className="flex text-black justify-between text-[12px]">
            <div>
              Total Post
            </div>
            {state?.communityId === communityData?.id
              ? communityData?.active_post_count - communityData?.active_deleted_post_count_by_other_person
              : selectedCommunity === communityData?.id
                ? communityData?.active_post_count - communityData?.active_deleted_post_count_by_other_person
                : communityData?.active_post_count - communityData?.active_deleted_post_count_by_other_person}
          </div>
        </span>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ChannelBox;
